import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useState, useEffect } from "react";
import "../../assets/css/modal.css";
import { useSelector } from "react-redux";
import ColorPicker from "../common/ColorPicker";
import axios from "axios";
import { Modal } from "react-bootstrap";

function TagModal({ handleClose, show, reloadList, data }) {
  useTranslation();
  const auth = useSelector((state) => state.auth);
  const [tag_title, setTag]   = useState("");
  const [tag_id,    setTagid] = useState("");
  const [color,     setColor] = useState("#4bc800");
  const [errors,    setErrors] = useState({});

  useEffect(() => {
    if (data) {
      setColor(data.tagcolor || "#4bc800");
      setTag(data.tag_title  || "");
      setTagid(data.id       || "");
      setErrors({});
    } else {
      setColor("#4bc800");
      setTag("");
      setTagid("");
      setErrors({});
    }
  }, [data]);

  const validate = () => {
    if (!tag_title.trim()) {
      setErrors({ tag_title: "Tag name is required" });
      return false;
    }
    setErrors({});
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      const body = JSON.stringify({ tag_id, tag_title, color, workspace_id: auth.workspace_id });

      if (tag_id) {
        await axios.put("/api/tag/edit", body, config);
      } else {
        await axios.post("/api/tag/add", body, config);
      }
      handleClose();
      reloadList();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName='add-New-tag-popup-box-container'
      centered
    >
      {/* ── Header ── */}
      <div className='pm-header'>
        <h3 className='pm-title'>{tag_id ? tr("Edit Tag") : tr("New Tag")}</h3>
        <button className='pm-close' onClick={handleClose} aria-label={tr("Close")}>
          <svg width='14' height='14' viewBox='0 0 14 14' fill='none'>
            <path d='M1 1l12 12M13 1L1 13' stroke='currentColor' strokeWidth='2' strokeLinecap='round'/>
          </svg>
        </button>
      </div>

      {/* ── Body ── */}
      <div className='pm-body'>
        <div className='pm-field'>
          <label className='pm-label'>{tr("Tag Name")}</label>
          <input
            className='pm-input'
            type='text'
            placeholder={tr("e.g. Design, Backend, Billable")}
            value={tag_title}
            onChange={(e) => setTag(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            autoFocus
          />
          {errors.tag_title && (
            <span className='pm-error'>{errors.tag_title}</span>
          )}
        </div>

        <div className='pm-field'>
          <label className='pm-label'>{tr("Color")}</label>
          <ColorPicker
            onSelectColor={(c) => setColor(c)}
            dbColor={color}
          />
        </div>
      </div>

      {/* ── Footer ── */}
      <div className='pm-footer'>
        <button className='pm-btn-cancel' onClick={handleClose}>{tr("Cancel")}</button>
        <button className='pm-btn-create' onClick={handleSubmit}>
          {tag_id ? tr("Update Tag") : tr("Create Tag")}
        </button>
      </div>
    </Modal>
  );
}

export default TagModal;
